export enum WaterFactorSourceType {
  MANUAL = "MANUAL",
  INTELLIGENT_SUGGESTION = "INTELLIGENT_SUGGESTION",
  REVERT = "REVERT"
}
